// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js'
import { sync } from 'vuex-router-sync'
import VueQrcodeReader from 'vue-qrcode-reader'
import i18n from '@/i18n/index.js'
import CountryFlag from 'vue-country-flag'

/* BOOTSTRAP */
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

/* FONT-AWESOME */
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faMinus, faShoppingCart, faCheckCircle, faTimesCircle, faExclamationTriangle, faSmile, faArrowLeft, faFilter, faGlobe } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faPlus, faMinus, faShoppingCart, faCheckCircle, faTimesCircle, faExclamationTriangle, faSmile, faArrowLeft, faFilter, faGlobe)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('country-flag', CountryFlag)
Vue.use(BootstrapVue)
Vue.use(VueQrcodeReader)

Vue.config.productionTip = false
sync(store, router)

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted () {
    this.$store.dispatch('fetchLocalStorage')
  }
})



// WEBPACK FOOTER //
// ./src/main.js